import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';// Add this for the person-circle icon
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Header = () => {
    const { user, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
                <Link className="navbar-brand" to={user?.role === 'admin' ? '/' : '/accounts'}>Trading 897</Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    {user ? (
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            {user.role === 'admin' ? (
                                <>
                                    {/* <li className="nav-item">
                                        <Link className="nav-link" to="/order-history">Order History</Link>
                                    </li> */}
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/">Accounts</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/algo">Algo</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/OwnAlgo">Own Algo</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/trade-dashboard">Trade Dashboard</Link>
                                    </li>
                                    {user.role === 'admin' && (
                                        <>
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/users">Users</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/manage-accounts">Old</Link>
                                            </li>
                                        </>
                                    )}
                                </>
                            ) : (
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">
                                        Accounts
                                    </Link>
                                </li>
                            )}
                        </ul>
                    ) : (
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/login">Login</Link>
                            </li>
                        </ul>
                    )}
                    {user && (
                        <button className="btn" onClick={handleLogout}>
                            Logout
                        </button>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Header;